import React from "react";
import Header from "../components/Header";

function Home() {
  return (
    <div className="home">
      <Header />
    </div>
  );
}

export default Home;
